import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'gatsby'

const Item = ({ title, icon, path }) => (
  <div className='col-lg-3 col-md-6'>
    <div className='blog-post icon-text layout-6 wow fadeInUp'>
      <Link to={path}>
        <div className='icon'>
          <img src={`assets/icons/${icon}`} alt='' />
        </div>
        <h3>{title}</h3>
      </Link>
    </div>
  </div>
)

Item.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  path: PropTypes.string.isRequired
}

Item.defaultProps = {
  title: '',
  icon: ''
}

export default Item
